export const featuredStat = {
  value: 12,
  prefix: '−',
  suffix: ' %',
  label: 'de réduction moyenne des coûts sur les catégories d’achats renégociées',
};

export const stats = [
  { value: 150, prefix: '+', suffix: '', label: 'fournisseurs évalués, négociés ou sourcés' },
  { value: 30, prefix: '−', suffix: ' %', label: 'de stocks dormants après refonte des approvisionnements' },
  { value: 98, prefix: '', suffix: ' %', label: 'de taux de service atteint chez nos clients logistiques' },
];
